import {doppeActionTypeDefineMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeHideableValue,
    doppeHideableValueCreateHidden
} from '../../client-server-common/types/doppe-hideable-value';
import {DoppeActionTypeOutfitViewerLang} from './doppe-action-type-outfit-viewer.lang';
import {DoppeActionTypeProduct} from '../doppe-action-type-product/doppe-action-type-product';
import {arrayRemoveNullValues, immerProduce, iterableMapToArray, PartiallyOptional} from '@wix/devzai-utils-common';
import {WixImageResource, wixMediaResourceReplaceExternalImage} from '@wix/devzai-common-wix';
import {
    DoppeActionLayout,
    DoppeActionListItemClickBehaviour,
    doppeExternalProductProviderResolveBusinessEntityReference
} from '../../client-server-common';

export namespace DoppeActionTypeOutfit {

    export interface ProductSettings extends DoppeActionTypeProduct.ActionSettings {
        id: string;
        productTitle: string;
    }

    export interface ActionSettings {
        outfitImage: WixImageResource | null;
        outfitTitle: DoppeHideableValue<string>;
        products: ProductSettings[];
        layout: DoppeActionLayout;
        latestNonPremiumLayout?: DoppeActionLayout;
        itemClickBehaviour: DoppeActionListItemClickBehaviour;
    }
}

export const doppeActionTypeOutfit = doppeActionTypeDefineMetadata<DoppeActionTypeOutfit.ActionSettings>({
    id: 'io.bymo.action/outfit',
    resolveActionSettings: action => {

        const {
            products = [],
            ...restSettings
        } = action.settings;

        return {
            products: products.map(product => {
                return {
                    productProvider: null,
                    productProviderId: null,
                    ribbon: doppeHideableValueCreateHidden('SALE'),
                    ...product as PartiallyOptional<DoppeActionTypeOutfit.ProductSettings, 'productProvider' | 'productProviderId' | 'ribbon'>
                }
            }) ?? [],
            outfitImage: null,
            outfitTitle: DoppeActionTypeOutfitViewerLang.defaultTexts.outfitTitle,
            layout: DoppeActionLayout.Grid,
            itemClickBehaviour: DoppeActionListItemClickBehaviour.PreviewItem,
            ...restSettings
        }
    },
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    resolveUsedMedia: actionSettings => {
        return arrayRemoveNullValues([actionSettings.outfitImage]);
    },
    resolveUsedBusinessEntities: actionSettings => {
        return iterableMapToArray(actionSettings.products, (product, skip) => {
            return product.productProvider !== null && product.productProviderId !== null ?
                doppeExternalProductProviderResolveBusinessEntityReference(
                    product.productProvider,
                    product.productProviderId
                ) : skip
        });
    },
    resolveListItemsCount: actionSettings => {
        return actionSettings.products.length;
    },
    replaceExternalImages: (actionSettings, externalImagesUrlToImageResourceMap) => {
        return immerProduce(actionSettings, actionSettings => {
            if (actionSettings.outfitImage) {
                actionSettings.outfitImage =
                    wixMediaResourceReplaceExternalImage(actionSettings.outfitImage, externalImagesUrlToImageResourceMap)
            }
        })
    },

});